/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ConfluenceData,
  ConfluenceData$inboundSchema,
  ConfluenceData$Outbound,
  ConfluenceData$outboundSchema,
} from "./confluencedata.js";
import {
  OAuthRefreshTokenCredentials,
  OAuthRefreshTokenCredentials$inboundSchema,
  OAuthRefreshTokenCredentials$Outbound,
  OAuthRefreshTokenCredentials$outboundSchema,
} from "./oauthrefreshtokencredentials.js";

export type AuthenticatorConfluenceConnection = {
  provider: "confluence";
  data: Array<ConfluenceData>;
  credentials: OAuthRefreshTokenCredentials;
};

/** @internal */
export const AuthenticatorConfluenceConnection$inboundSchema: z.ZodType<
  AuthenticatorConfluenceConnection,
  z.ZodTypeDef,
  unknown
> = z.object({
  provider: z.literal("confluence"),
  data: z.array(ConfluenceData$inboundSchema),
  credentials: OAuthRefreshTokenCredentials$inboundSchema,
});
/** @internal */
export type AuthenticatorConfluenceConnection$Outbound = {
  provider: "confluence";
  data: Array<ConfluenceData$Outbound>;
  credentials: OAuthRefreshTokenCredentials$Outbound;
};

/** @internal */
export const AuthenticatorConfluenceConnection$outboundSchema: z.ZodType<
  AuthenticatorConfluenceConnection$Outbound,
  z.ZodTypeDef,
  AuthenticatorConfluenceConnection
> = z.object({
  provider: z.literal("confluence"),
  data: z.array(ConfluenceData$outboundSchema),
  credentials: OAuthRefreshTokenCredentials$outboundSchema,
});

export function authenticatorConfluenceConnectionToJSON(
  authenticatorConfluenceConnection: AuthenticatorConfluenceConnection,
): string {
  return JSON.stringify(
    AuthenticatorConfluenceConnection$outboundSchema.parse(
      authenticatorConfluenceConnection,
    ),
  );
}
export function authenticatorConfluenceConnectionFromJSON(
  jsonString: string,
): SafeParseResult<AuthenticatorConfluenceConnection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthenticatorConfluenceConnection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthenticatorConfluenceConnection' from JSON`,
  );
}
